import { render, staticRenderFns } from "./SSupplier.vue?vue&type=template&id=432478c0"
import script from "./SSupplier.vue?vue&type=script&lang=js"
export * from "./SSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports